import React, { Component } from 'react';
import Header from '../../../components/Header/Header';

import illustration from '../../../assets/img/illustrations/404.png'
// Import Style
import '../style.scss';

class GeneralError extends Component {
  render() {
    return (
      <div className='downtime'>
        <Header showHome={false} />

        <div className='downtime_wrap'>
          <div className='downtime_content'>
            <h1>Something went wrong</h1>
            <p>We're experiencing technical difficulties at the moment please try again later!</p>
            <a className='btn btn-primary' href="/login" id="loginBtn">
              Let's try that again
            </a>
          </div>
          
          <div className='downtime_icon'>
            <img alt="downtime icon" src={illustration}/>
          </div>
        </div>
      </div>
    );
  }
}
export default GeneralError;
